import React, { Component, } from "react"
import Select from '@mui/material/Select';
import { FaChevronCircleDown } from 'react-icons/fa';
import Grid from '@mui/material/Grid';
import { Button, Typography, Box, ListItemAvatar, Avatar, ButtonGroup } from "@mui/material";
import { logNavigation } from "../common/mixpanelInterface";
import List from '@mui/material/List';
import Modal from '@mui/material/Modal';
import CircularProgress from "@mui/material/CircularProgress";
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import getGeoInfo from '../common/common/getGeoInfo';
import CreatePriceStr from '../common/common/CreatePriceStr';
import get_and_post_data_skeleton from '../common/common/get_and_post_data_skeleton';
import PieCard from './user_analytics/PieCard';
import axios from 'axios';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import {
   BarChart, Bar, XAxis, YAxis, CartesianGrid, LineChart, Line, Tooltip, ResponsiveContainer, ReferenceArea,
   AreaChart, Area, PieChart, Pie, Cell, RadialBarChart, RadialBar, Legend, ComposedChart, RadarChart, PolarGrid, PolarAngleAxis, PolarRadiusAxis, Radar,
} from 'recharts';
import { FiUsers, FiDollarSign, FiEye, FiAward } from "react-icons/fi";
import { Thumbs } from "swiper";
import Loader from "../common/Loader";
import PageSkeletonAnalytics from "../common/skeletons/PageSkeletonAnalytics";
const paths = require('../../paths.json');

const TIER_COLORS = ['#008EBA', '#B1560F', '#A1A2A3', '#F9A602'];

const smallHeading = {
   fontWeight: '500',
   fontSize: '14px',
   color: '#000',
   margin: '0px 0px 5px 0px',
   fontFamily: 'Roboto'
};

const modalStyle = {
   display: 'flex',
   height: 'auto',
   // bgcolor: 'rgba(0,0,0,1)',
   minHeight: '100vh',
   minWidth: '100vw',
   overflowY: 'hidden',
   outline: 'none',
   zIndex: '9999',
};

const largeNumber = {
   fontWeight: 'bold',
   fontSize: '24px',
   color: '#000',
   fontFamily: 'Roboto'
};

const smallText = {
   fontSize: '12px',
   color: 'green',
};

const iconStyle = {
   position: 'absolute',
   top: '20px',
   right: '20px',
};

const titleStyle = {
   fontWeight: 'bold',
   fontSize: '14px',
   color: '#000',
   marginBottom: '15px',
};

const COLORS = ['#0088FE', '#00C49F', '#FFBB28', '#FF8042'];


const membershipBreakdownData = [
   { name: 'Free', value: 400, fill: '#0088FE' },
   { name: 'Bronze', value: 300, fill: '#00C49F' },
   { name: 'Silver', value: 300, fill: '#FFBB28' },
   { name: 'Gold', value: 200, fill: '#FF8042' },
];


// const dataTest = 
//    [
//       [
//           "Sep-23",
//           6,
//           null
//       ],
//       [
//           "Oct-23",
//           3059.9372,
//           null
//       ],
//       [
//           "Nov-23",
//           3499,
//           null
//       ],
//       [
//           "Dec-23",
//           3429,
//           null
//       ],
//       [
//           "Jan-24",
//           2867.9726,
//           null
//       ],
//       [
//           "Feb-24",
//           4214,
//           null
//       ],
//       [
//           "Mar-24",
//           3459,
//           null
//       ],
//       [
//           "Apr-24",
//           3439,
//           null
//       ],
//       [
//           "May-24",
//           2549.792,
//           null
//       ],
//       [
//           "Jun-24",
//           4159,
//           null
//       ],
//       [
//           "Jul-24",
//           3959,
//           null
//       ],
//       [
//           "Aug-24",
//           232,
//           1932
//       ]
//   ]


// STRESS TESTING
const dataTest1 = [
   ["Sep-23", 650, null],
   ["Oct-23", 750, null],
   ["Nov-23", 820, null],
   ["Dec-23", 1200, null],
   ["Jan-24", 1350, null],
   ["Feb-24", 900, null],
   ["Mar-24", 1050, null],
   ["Apr-24", 950, null],
   ["May-24", 600, null],
   ["Jun-24", 850, null],
   ["Jul-24", 780, null],
   ["Aug-24", 950, 1800]
];

const dataTest2 = [
   ["Sep-23", 100, null],
   ["Oct-23", 3200, null],
   ["Nov-23", 3700, null],
   ["Dec-23", 50, null],
   ["Jan-24", 2900, null],
   ["Feb-24", 4100, null],
   ["Mar-24", 200, null],
   ["Apr-24", 3500, null],
   ["May-24", 2600, null],
   ["Jun-24", 4300, null],
   ["Jul-24", 4000, null],
   ["Aug-24", 300, 1900]
];

const dataTest3 = [
   ["Sep-23", 5.65, null],
   ["Oct-23", 3100.47, null],
   ["Nov-23", 3400.75, null],
   ["Dec-23", 3450.12, null],
   ["Jan-24", 2900.67, null],
   ["Feb-24", 4200.88, null],
   ["Mar-24", 3500.54, null],
   ["Apr-24", 3400.23, null],
   ["May-24", 2550.45, null],
   ["Jun-24", 4100.67, null],
   ["Jul-24", 3900.78, null],
   ["Aug-24", 300.12, 2000.34]
];




const revenueData = [
   { name: 'Jan', value: 4000 },
   { name: 'Feb', value: 3000 },
   { name: 'Mar', value: 5000 },
   { name: 'Apr', value: 4000 },
   { name: 'May', value: 6000 },
   { name: 'Jun', value: 7000 },
   { name: 'Jul', value: 8000 },
   { name: 'Aug', value: 5000 },
   { name: 'Sep', value: 4000 },
   { name: 'Oct', value: 6000 },
   { name: 'Nov', value: 7000 },
   { name: 'Dec', value: 8000 },
];

const membershipsData = [
   { name: 'Jan', value: 150 },
   { name: 'Feb', value: 200 },
   { name: 'Mar', value: 250 },
   { name: 'Apr', value: 220 },
   { name: 'May', value: 280 },
   { name: 'Jun', value: 300 },
   { name: 'Jul', value: 350 },
   { name: 'Aug', value: 320 },
   { name: 'Sep', value: 310 },
   { name: 'Oct', value: 330 },
   { name: 'Nov', value: 370 },
   { name: 'Dec', value: 390 },
];

const viewsData = [
   { name: 'Jan', value: 8000 },
   { name: 'Feb', value: 9000 },
   { name: 'Mar', value: 10000 },
   { name: 'Apr', value: 9500 },
   { name: 'May', value: 10500 },
   { name: 'Jun', value: 11000 },
   { name: 'Jul', value: 11500 },
   { name: 'Aug', value: 10000 },
   { name: 'Sep', value: 9000 },
   { name: 'Oct', value: 9500 },
   { name: 'Nov', value: 10000 },
   { name: 'Dec', value: 11000 },
];

const members = [
   { name: 'John Doe', email: 'john@example.com', cost: '50' },
   { name: 'Jane Smith', email: 'jane@example.com', cost: '40' },
   { name: 'Michael Johnson', email: 'michael@example.com', cost: '60' },
   { name: 'John Doe', email: 'john@example.com', cost: '50' },
   { name: 'Jane Smith', email: 'jane@example.com', cost: '40' },
   { name: 'Michael Johnson', email: 'michael@example.com', cost: '9.40' },
   { name: 'John Doe', email: 'john@example.com', cost: '9.99' },
   { name: 'Jane Smith', email: 'jane@example.com', cost: '40' },
   { name: 'Michael Johnson', email: 'michael@example.com', cost: '60' },
];

const axisTickStyle = {
   fontWeight: 'bold',
   fontSize: '9px',
   color: '#6E89AF',
};

class TopFive extends Component {
   constructor(props) {
      super(props);
      this.state = {
      };
   }
   render() {
      let content_block = ""
      if (this.props.top_five_data.length === 0) {
         content_block =
            <div style={{ height: '100%', width: '100%', display: 'flex' }}>
               <p style={{ textAlign: 'center', color: 'var(--secondary-text-color)', margin: '70px auto 0px auto', fontSize: '14px', fontWeight: '500' }}>No views for this time range</p>
            </div>
      } else {
         content_block =
            <List dense sx={{
               width: '100%', maxWidth: 300, backgroundColor: '--rebranding-content-background-color', margin: 'auto', textAlign: 'center'
            }}>
               {this.props.top_five_data.map((value, index) => {
                  const labelId = `checkbox-list-secondary-label-${value.content__id}`;
                  return (
                     <ListItem
                        sx={{ marginBottom: '10px' }}
                        key={value.content__id}
                        disablePadding
                     >
                        <ListItemText
                           disableTypography
                           className='line_text'
                           id={labelId} primary={`${value.count} - ${value.content__name.slice(0, 20)}...`} />

                     </ListItem>
                  );
               })}
            </List>
      }
      return (

         <div style={{
            border: '1px solid #E4EBF6',
            borderRadius: '8px',
            padding: '25px 20px 30px 20px',
            backgroundColor: '#fff',
            minHeight: '270px',
            boxSizing: 'border-box',
            marginTop: '20px',
            height: 'auto',
            width: 'auto',
         }}>
            <p style={{ ...smallHeading, textAlign: 'center', margin: '0px 0px 15px 0px' }}>{this.props.title}</p>

            {content_block}

         </div>
      )
   }
}


const LatestMembers = (currency_symbol) => {

   let sign = currency_symbol

   return (
      <Box sx={{ border: '1px solid #E4EBF6', borderRadius: '8px', padding: '16px', boxSizing: 'border-box', backgroundColor: '#fff', height: '100%', }}>
         <Typography style={{ ...smallHeading, margin: '0px 0px 5px 0px' }} fontWeight="bold">
            Latest Members
         </Typography>
         <List style={{ maxHeight: '300px', overflow: 'auto', }}>
            {members.map((member, index) => (
               <div style={{ display: 'flex', margin: '0px 0px 15px 0px' }}>
                  <ListItem key={index} sx={{ padding: '0px' }}>
                     <ListItemAvatar sx={{ padding: '0px', minWidth: '47px' }}>
                        <Avatar sx={{ width: '35px', height: '35px' }}>{member.name[0]}</Avatar>
                     </ListItemAvatar>
                     <div style={{ display: 'grid' }}>
                        <span style={{ fontSize: '13px', fontWeight: '500' }}>{member.name}</span>
                        <span style={{ fontSize: '13px', color: '#6E89AF', fontWeight: '500' }}>{member.email}</span>
                     </div>

                     {/* <ListItemText
             sx={{ col }}
               primary={member.name}
               secondary={`${member.email}`}
             /> */}

                     <span style={{ marginLeft: 'auto', fontWeight: '500', fontSize: '14px' }}>{currency_symbol.currency_symbol}{member.cost}</span>

                  </ListItem>
               </div>
            ))}
         </List>
      </Box>
   );
};


const TopBox = ({ title, value, change, icon }) => {
   return (
      <Box sx={{ position: 'relative', backgroundColor: '#fff', width: '100%', height: '100%', borderRadius: '8px', border: '1px solid #E4EBF6', padding: '20px', boxSizing: 'border-box' }}>
         <div style={smallHeading}>{title}</div>
         <div style={iconStyle}>{icon}</div>
         <div style={largeNumber}>{value}</div>
         {/* <div style={smallText}>{change} increased</div> */}
      </Box>
   );
};




const CustomTooltip = ({ active, payload, type, currency }) => {
   if (active && payload && payload.length) {
      // console.log('payload', payload)
      return (
         <div style={{ backgroundColor: '#fff', border: '1px solid #ddd', padding: '0px 10px', borderRadius: '8px' }}>

            {
               payload[0].payload['value2'] !== payload[0].payload['value1'] ?
                  // The last month with two values
                  <>
                     <p style={{ fontWeight: 'bold', margin: '10px 0px 0px 0px' }}>{payload[0].payload['month']}</p>

                     <p style={{ margin: '0px 0px 0px 0px' }}>
                        <span>{type === 'revenue' ? ('Projected End of Month Revenue: ' + (currency === 'GBP' ? '£' : (currency === 'EUR' ? '€' : '$')))
                           : type === 'memberships' ? 'Projected End of Month Memberships: ' : 'Projected End of Month Views: '}</span>{payload[0].payload['value2']}
                     </p>
                     <p style={{ margin: '0px 0px 10px 0px' }}>
                        <span>{type === 'revenue' ? ('Revenue: ' + (currency === 'GBP' ? '£' : (currency === 'EUR' ? '€' : '$')))
                           : type === 'memberships' ? 'Memberships: ' : 'Views: '}</span>{payload[0].payload['value1']}
                     </p>





                  </>
                  :
                  // All months which only contain one value
                  <>
                     <p style={{ fontWeight: 'bold', margin: '10px 0px 0px 0px' }}>{payload[0].payload['month']}</p>
                     <p style={{ margin: '0px 0px 10px 0px' }}><span>
                        {type === 'revenue' ? ('Revenue: ' +

                           (currency === 'GBP' ? '£' : (currency === 'EUR' ? '€' : '$')))

                           : type === 'memberships' ? 'Memberships: ' : 'Views: '}</span>{payload[0].value}</p></>
            }
         </div>
      );
   }

   return null;
};


const transformData = (data) => {
   const transformedData = data.map(([month, value1, value2]) => {
      const parsedValue1 = value1 !== null && value1 !== undefined ? Number(value1) : Number(value1);
      const parsedValue2 = value2 !== null && value2 !== undefined ? Number(value2) : Number(value1);

      const roundedValue1 = parseFloat(parsedValue1.toFixed(2));
      const roundedValue2 = parsedValue2 !== null ? parseFloat(parsedValue2.toFixed(2)) : parseFloat(parsedValue2.toFixed(2));

      return {
         month,
         value1: roundedValue1,
         value2: roundedValue2,
      };
   });

   // console.log("Transformed Data:", transformedData); 
   return transformedData;
};





// const MonthlyOverview = ({ selected, updateSelected, overviewData, graphDataLoading, windowWidth, currency }) => {
//    // console.log('overviewData', overviewData)
//    const data = transformData(overviewData);
//    const minValue = Math.min(...data.map(item => Math.min(item.value1, item.value2)));
//    let maxValue = Math.max(...data.map(item => Math.max(item.value1, item.value2)));
//    const paddedValue = Math.round(maxValue + (maxValue * 0.1));
//    // console.log('minValue', maxValue)


//    return (
//       <Box sx={{ backgroundColor: '#fff', width: '100%', height: '100%', borderRadius: '8px', border: '1px solid #E4EBF6', padding: '15px', boxSizing: 'border-box', paddingBottom: windowWidth < 600 ? '20px' : '' }}>
//       {
//         windowWidth < 600 ?
//           null :
//           <div style={{ position: 'relative' }}>
//             <ButtonGroup variant="outlined" aria-label="Basic button group" sx={{ fontFamily: 'roboto', position: 'absolute', top: '0px', right: '0px', zIndex: '999', height: '30px' }}>
//               <Button
//               disabled={graphDataLoading}
//                 sx={{
//                   border: '1px solid #E4EBF6',
//                   color: selected === 'revenue' ? '#fff' : '#000',
//                   textTransform: 'capitalize',
//                   fontSize: '13px',
//                   backgroundColor: selected === 'revenue' ? 'var(--brand-color)' : '#fff',
//                   '&:hover': {
//                     backgroundColor: selected === 'revenue' ? 'var(--brand-color)' : '#F5F9FF',
//                     border: '1px solid #E4EBF6'
//                   },
//                 }}
//                 onClick={() => updateSelected('revenue')}
//               >
//                 Revenue
//               </Button>
//               <Button
//               disabled={graphDataLoading}
//                 sx={{
//                   border: '1px solid #E4EBF6',
//                   fontFamily: 'roboto',
//                   textTransform: 'capitalize',
//                   fontSize: '13px',
//                   color: selected === 'memberships' ? '#fff' : '#000',
//                   backgroundColor: selected === 'memberships' ? 'var(--brand-color)' : '#fff',
//                   '&:hover': {
//                     backgroundColor: selected === 'memberships' ? 'var(--brand-color)' : '#F5F9FF',
//                     border: '1px solid #E4EBF6'
//                   },
//                 }}
//                 onClick={() => updateSelected('memberships')}
//               >
//                 Memberships
//               </Button>
//               <Button
//               disabled={graphDataLoading}
//                 sx={{
//                   border: '1px solid #E4EBF6',
//                   textTransform: 'capitalize',
//                   fontSize: '13px',
//                   color: selected === 'views' ? '#fff' : '#000',
//                   backgroundColor: selected === 'views' ? 'var(--brand-color)' : '#fff',
//                   '&:hover': {
//                     backgroundColor: selected === 'views' ? 'var(--brand-color)' : '#F5F9FF',
//                     border: '1px solid #E4EBF6'
//                   },
//                 }}
//                 onClick={() => updateSelected('views')}
//               >
//                 Views
//               </Button>
//             </ButtonGroup>
//           </div>
//       }

//       <div style={{ ...smallHeading, paddingBottom: '30px' }}>Monthly Overview</div>

//       <ResponsiveContainer width="100%" height={windowWidth < 600 ? 250 : 400} style={{ position: 'relative' }}>
//         <CircularProgress style={{ display: graphDataLoading ? 'block' : 'none', color: 'var(--brand-color)', position: 'absolute', top: '40%', left: '50%', transform: 'translate(-50%, -50%)' }} />
//         <AreaChart
//           data={transformData(overviewData)}
//           margin={{
//             top: 10,
//             right: 30,
//             left: 0,
//             bottom: 0,
//           }}
//         >
//           <XAxis dataKey="month" axisLine={false} tickLine={false} tick={{ ...axisTickStyle }} />
//           <YAxis axisLine={false} 
//           domain={[minValue, paddedValue]} 
//           tickFormatter={(tick) => (selected === 'revenue' ? `£${tick.toFixed(2)}` : Math.round(tick))} tickLine={false} tick={{ ...axisTickStyle }} />
//           <Tooltip content={<CustomTooltip type={selected} currency={currency} />} />

//           <Area type="monotone" dataKey="value1" stroke="var(--brand-color)" fill="var(--brand-color)" />
//           <Area type="monotone" dataKey="value2" stroke="var(--success-color)"/>

//         </AreaChart>
//       </ResponsiveContainer>
//       <div style={{ width: '100%', display: 'flex' }}>
//         <span style={{ fontSize: '8px', color: '#666666', fontWeight: '500', margin: '0px 0px 0px auto' }}>*Project monthly revenue is only an estimation and may not always be accurate.</span>
//       </div>

//       {
//         windowWidth < 600 ?
//           <div style={{ position: 'relative', margin: 'auto', width: '100%', display: 'flex' }}>
//             <ButtonGroup  variant="outlined" aria-label="Basic button group" sx={{ fontFamily: 'roboto', margin: '20px auto auto auto', zIndex: '999', height: '30px' }}>
//               <Button
//               disabled={graphDataLoading}
//                 sx={{
//                   border: '1px solid #E4EBF6',
//                   color: selected === 'revenue' ? '#fff' : '#000',
//                   textTransform: 'capitalize',
//                   fontSize: '13px',
//                   backgroundColor: selected === 'revenue' ? 'var(--brand-color)' : '#fff',
//                   '&:hover': {
//                     backgroundColor: selected === 'revenue' ? 'var(--brand-color)' : '#F5F9FF',
//                     border: '1px solid #E4EBF6'
//                   },
//                 }}
//                 onClick={() => updateSelected('revenue')}
//               >
//                 Revenue
//               </Button>
//               <Button
//               disabled={graphDataLoading}
//                 sx={{
//                   border: '1px solid #E4EBF6',
//                   fontFamily: 'roboto',
//                   textTransform: 'capitalize',
//                   fontSize: '13px',
//                   color: selected === 'memberships' ? '#fff' : '#000',
//                   backgroundColor: selected === 'memberships' ? 'var(--brand-color)' : '#fff',
//                   '&:hover': {
//                     backgroundColor: selected === 'memberships' ? 'var(--brand-color)' : '#F5F9FF',
//                     border: '1px solid #E4EBF6'
//                   },
//                 }}
//                 onClick={() => updateSelected('memberships')}
//               >
//                 Memberships
//               </Button>
//               <Button
//               disabled={graphDataLoading}
//                 sx={{
//                   border: '1px solid #E4EBF6',
//                   textTransform: 'capitalize',
//                   fontSize: '13px',
//                   color: selected === 'views' ? '#fff' : '#000',
//                   backgroundColor: selected === 'views' ? 'var(--brand-color)' : '#fff',
//                   '&:hover': {
//                     backgroundColor: selected === 'views' ? 'var(--brand-color)' : '#F5F9FF',
//                     border: '1px solid #E4EBF6'
//                   },
//                 }}
//                 onClick={() => updateSelected('views')}
//               >
//                 Views
//               </Button>
//             </ButtonGroup>
//           </div>
//           :
//           null
//       }
//     </Box>
//    )
// }



const MonthlyOverview = ({ selected, updateSelected, overviewData, graphDataLoading, windowWidth, currency }) => {
   const data = transformData(overviewData);

   // const minValue = Math.min(...data.map(item => Math.min(item.value1 ?? Infinity, item.value2 ?? Infinity)));
   // Reset 0 to min to prevent positive values being display on the Y axis
   const minValue = 0;
   let maxValue = Math.max(...data.map(item => Math.max(item.value1 ?? -Infinity, item.value2 ?? -Infinity)));
   const paddedValue = Math.round(maxValue + (maxValue * 0.1));

   return (
      <Box sx={{ backgroundColor: '#fff', width: '100%', height: '100%', borderRadius: '8px', border: '1px solid #E4EBF6', padding: '15px', boxSizing: 'border-box', paddingBottom: windowWidth < 600 ? '20px' : '' }}>

         {
            windowWidth < 600 ? null :
               <div style={{ position: 'relative' }}>
                  <ButtonGroup variant="outlined" aria-label="Basic button group" sx={{ fontFamily: 'roboto', position: 'absolute', top: '0px', right: '0px', zIndex: '999', height: '30px' }}>
                     <Button
                        disabled={graphDataLoading}
                        sx={{
                           border: '1px solid #E4EBF6',
                           color: selected === 'revenue' ? '#fff' : '#000',
                           textTransform: 'capitalize',
                           fontSize: '13px',
                           backgroundColor: selected === 'revenue' ? 'var(--brand-color)' : '#fff',
                           '&:hover': {
                              backgroundColor: selected === 'revenue' ? 'var(--brand-color)' : '#F5F9FF',
                              border: '1px solid #E4EBF6'
                           },
                        }}
                        onClick={() => updateSelected('revenue')}
                     >
                        Revenue
                     </Button>
                     <Button
                        disabled={graphDataLoading}
                        sx={{
                           border: '1px solid #E4EBF6',
                           fontFamily: 'roboto',
                           textTransform: 'capitalize',
                           fontSize: '13px',
                           color: selected === 'memberships' ? '#fff' : '#000',
                           backgroundColor: selected === 'memberships' ? 'var(--brand-color)' : '#fff',
                           '&:hover': {
                              backgroundColor: selected === 'memberships' ? 'var(--brand-color)' : '#F5F9FF',
                              border: '1px solid #E4EBF6'
                           },
                        }}
                        onClick={() => updateSelected('memberships')}
                     >
                        Memberships
                     </Button>
                     <Button
                        disabled={graphDataLoading}
                        sx={{
                           border: '1px solid #E4EBF6',
                           textTransform: 'capitalize',
                           fontSize: '13px',
                           color: selected === 'views' ? '#fff' : '#000',
                           backgroundColor: selected === 'views' ? 'var(--brand-color)' : '#fff',
                           '&:hover': {
                              backgroundColor: selected === 'views' ? 'var(--brand-color)' : '#F5F9FF',
                              border: '1px solid #E4EBF6'
                           },
                        }}
                        onClick={() => updateSelected('views')}
                     >
                        Views
                     </Button>
                  </ButtonGroup>
               </div>
         }

         <div style={{ ...smallHeading, paddingBottom: '30px' }}>Monthly Overview</div>

         <ResponsiveContainer width="100%" height={windowWidth < 600 ? 250 : 400} style={{ position: 'relative' }}>
            <CircularProgress style={{ display: graphDataLoading ? 'block' : 'none', color: 'var(--brand-color)', position: 'absolute', top: '40%', left: '50%', transform: 'translate(-50%, -50%)' }} />
            <AreaChart
               data={data}
               margin={{
                  top: 10,
                  right: 30,
                  left: 0,
                  bottom: 0,
               }}
            >
               <XAxis dataKey="month" axisLine={false} tickLine={false} tick={{ ...axisTickStyle }} />
               <YAxis
                  axisLine={false}
                  domain={[minValue, paddedValue]}
                  tickFormatter={(tick) => (selected === 'revenue' ? `£${tick.toFixed(2)}` : Math.round(tick))}
                  tickLine={false}
                  tick={{ ...axisTickStyle }}
               />
               <Tooltip content={<CustomTooltip type={selected} currency={currency} />} />

               {/* Projected Area - rendered first, so it appears behind */}
               <Area
                  type="monotone"
                  dataKey="value2"
                  stroke="var(--success-color)"
                  fillOpacity={0.3}
                  fill="var(--success-color)"
               />

               {/* Main Area - rendered second, so it appears in front */}
               <Area
                  type="monotone"
                  dataKey="value1"
                  stroke="var(--brand-color)"
                  fill="var(--brand-color)"
               />
            </AreaChart>
         </ResponsiveContainer>

         {/* Footer Note */}
         <div style={{ width: '100%', display: 'flex' }}>
            <span style={{ fontSize: '8px', color: '#666666', fontWeight: '500', margin: '0px 0px 0px auto' }}>
               *Projected monthly revenue is only an estimation and may not always be accurate.
            </span>
         </div>

         {/* Bottom Button Group for mobile screens */}
         {
            windowWidth < 600 ?
               <div style={{ position: 'relative', margin: 'auto', width: '100%', display: 'flex' }}>
                  <ButtonGroup variant="outlined" aria-label="Basic button group" sx={{ fontFamily: 'roboto', margin: '20px auto auto auto', zIndex: '999', height: '30px' }}>
                     <Button
                        disabled={graphDataLoading}
                        sx={{
                           border: '1px solid #E4EBF6',
                           color: selected === 'revenue' ? '#fff' : '#000',
                           textTransform: 'capitalize',
                           fontSize: '13px',
                           backgroundColor: selected === 'revenue' ? 'var(--brand-color)' : '#fff',
                           '&:hover': {
                              backgroundColor: selected === 'revenue' ? 'var(--brand-color)' : '#F5F9FF',
                              border: '1px solid #E4EBF6'
                           },
                        }}
                        onClick={() => updateSelected('revenue')}
                     >
                        Revenue
                     </Button>
                     <Button
                        disabled={graphDataLoading}
                        sx={{
                           border: '1px solid #E4EBF6',
                           fontFamily: 'roboto',
                           textTransform: 'capitalize',
                           fontSize: '13px',
                           color: selected === 'memberships' ? '#fff' : '#000',
                           backgroundColor: selected === 'memberships' ? 'var(--brand-color)' : '#fff',
                           '&:hover': {
                              backgroundColor: selected === 'memberships' ? 'var(--brand-color)' : '#F5F9FF',
                              border: '1px solid #E4EBF6'
                           },
                        }}
                        onClick={() => updateSelected('memberships')}
                     >
                        Memberships
                     </Button>
                     <Button
                        disabled={graphDataLoading}
                        sx={{
                           border: '1px solid #E4EBF6',
                           textTransform: 'capitalize',
                           fontSize: '13px',
                           color: selected === 'views' ? '#fff' : '#000',
                           backgroundColor: selected === 'views' ? 'var(--brand-color)' : '#fff',
                           '&:hover': {
                              backgroundColor: selected === 'views' ? 'var(--brand-color)' : '#F5F9FF',
                              border: '1px solid #E4EBF6'
                           },
                        }}
                        onClick={() => updateSelected('views')}
                     >
                        Views
                     </Button>
                  </ButtonGroup>
               </div>
               :
               null
         }
      </Box>
   )
}


const renderCustomLabel = ({ name, value }) => `${name}: ${value}`;



const memberData = [
   {
      name: 'Page A',
      uv: 4000,
      pv: 2400,
      amt: 2400,
   },
   {
      name: 'Page B',
      uv: 3000,
      pv: 1398,
      amt: 2210,
   },
   {
      name: 'Page C',
      uv: 2000,
      pv: 9800,
      amt: 2290,
   },
   {
      name: 'Page D',
      uv: 2780,
      pv: 3908,
      amt: 2000,
   },
   {
      name: 'Page E',
      uv: 1890,
      pv: 4800,
      amt: 2181,
   },
   {
      name: 'Page F',
      uv: 2390,
      pv: 3800,
      amt: 2500,
   },
   {
      name: 'Page G',
      uv: 3490,
      pv: 4300,
      amt: 2100,
   },
];


const membershipData = [
   { name: 'Free', members: 400 },
   { name: 'Bronze', members: 300 },
   { name: 'Silver', members: 300 },
   { name: 'Gold', members: 200 },
];

const MembershipBreakdown = (windowWidth) => {
   return (
      <Box sx={{ backgroundColor: '#fff', width: '100%', height: '100%', borderRadius: '8px', border: '1px solid #E4EBF6', padding: '15px', boxSizing: 'border-box' }}>
         <div style={smallHeading}>Membership Breakdown</div>

         <ResponsiveContainer width="100%" height={windowWidth < 600 ? 300 : 400} style={{ paddingTop: '20px', marginLeft: '-20px' }}>
            <BarChart data={membershipData}>
               <XAxis axisLine={false} tickLine={false} dataKey="name" tick={{ ...axisTickStyle }} />
               <YAxis axisLine={false} tickLine={false} tick={{ ...axisTickStyle }} />
               <Tooltip content={<CustomTooltip />} />
               <Bar dataKey="members" stroke="var(--brand-color)" fill="#8A99F9" radius={[4, 4, 0, 0]} />
            </BarChart>
         </ResponsiveContainer>
      </Box>
   );
};


// check the array, if empty return true if not empty return false. check each value to see if above 0
const processViews = (data) => {
   let processedData = []
   data.forEach((element) => {
      if (element[1] > 0) {
         processedData.push(element)
      }
   })
   return processedData

}


const composedData = [
   { name: 'Jan', uv: 590, pv: 800, amt: 1400 },
   { name: 'Feb', uv: 868, pv: 967, amt: 1506 },
   { name: 'Mar', uv: 1397, pv: 1098, amt: 989 },
   { name: 'Apr', uv: 1480, pv: 1200, amt: 1228 },
   { name: 'May', uv: 1520, pv: 1108, amt: 1100 },
   { name: 'Jun', uv: 1400, pv: 680, amt: 1700 },
];

const MonthlyComposedChart = (windowWidth) => {
   return (
      <Box sx={{ backgroundColor: '#fff', width: '100%', height: '100%', borderRadius: '8px', border: '1px solid #E4EBF6', padding: '15px', boxSizing: 'border-box' }}>
         <div style={{ ...smallHeading, paddingBottom: '15px' }}>Growth Forecast</div>
         <ResponsiveContainer width="100%" height={windowWidth < 600 ? 300 : 380}>
            <ComposedChart data={composedData}>
               {/* <CartesianGrid stroke="#f5f5f5" /> */}
               <XAxis dataKey="name" axisLine={false} tickLine={false} tick={{ ...axisTickStyle }} />
               <YAxis axisLine={false} tickLine={false} tick={{ ...axisTickStyle }} />
               <Tooltip />
               {/* <Legend /> */}
               <Bar dataKey="pv" barSize={20} fill="#8A99F9" />
               <Line type="monotone" dataKey="uv" stroke="var(--brand-color)" />
            </ComposedChart>
         </ResponsiveContainer>
      </Box>
   );
};


const radarData = [
   { subject: 'Image', A: 120, B: 110, fullMark: 150 },
   { subject: 'Video', A: 98, B: 130, fullMark: 150 },
   { subject: 'PDF', A: 86, B: 130, fullMark: 150 },
   { subject: 'Audio', A: 99, B: 100, fullMark: 150 },
   { subject: 'Text', A: 85, B: 90, fullMark: 150 },
   { subject: 'Live', A: 85, B: 90, fullMark: 150 },
];

const MembershipRadarChart = (windowWidth) => {
   return (
      <Box sx={{ backgroundColor: '#fff', width: '100%', height: '100%', borderRadius: '8px', border: '1px solid #E4EBF6', padding: '15px', boxSizing: 'border-box' }}>
         <div style={smallHeading}>Content Performance</div>
         <ResponsiveContainer width="100%" height={windowWidth < 600 ? 300 : 400}>
            <RadarChart cx="50%" cy="50%" outerRadius="80%" data={radarData}>
               <PolarGrid />
               <PolarAngleAxis dataKey="subject" tick={{ ...axisTickStyle }} />
               <PolarRadiusAxis />
               <Tooltip />
               <Radar name="Mike" dataKey="A" stroke="var(--brand-color)" fill="var(--brand-color)" fillOpacity={0.6} />
               {/* <Radar name="Lily" dataKey="B" stroke="var(--brand-color)" fill="#8A99F9" fillOpacity={0.6} /> */}
               {/* <Legend /> */}
            </RadarChart>
         </ResponsiveContainer>
      </Box>
   );
};








class InfluencerAnalytics extends Component {
   constructor(props) {
      super(props);
      this.state = {
         numDays: 7,
         n_free_subs: 0,
         n_bronze_subs: 0,
         n_silver_subs: 0,
         n_gold_subs: 0,
         n_total_subs: 0,
         n_sub_cancellations: 0,
         n_sub_upgrades: 0,
         n_sub_free_upgrades: 0,
         n_sub_downgrades: 0,
         n_sub_new: 0,
         uploaded_content_categories: [],
         uploaded_content_content_type: [],
         uploaded_content_content_tier: [],
         total_content_views: 0,
         total_content_likes: 0,
         total_content_saves: 0,
         top_5_content_views: [],
         content_category_views: [],
         content_content_type_views: [],
         content_tier_views: [],
         top_5_content_likes: [],
         content_category_likes: [],
         content_content_type_likes: [],
         content_tier_likes: [],
         top_5_content_save: [],
         content_category_save: [],
         content_content_type_save: [],
         content_tier_save: [],
         n_page_views: 0,
         n_uploaded_content: 0,
         n_page_views_change: 0,
         n_uploaded_content_change: 0,
         n_sub_new_change: 0,
         n_sub_upgrades_change: 0,
         n_sub_free_upgrades_change: 0,
         n_sub_downgrades_change: 0,
         n_sub_cancel_change: 0,
         prev_month_revenue: 0,
         this_month_revenue: 0,
         last_month_refund_count: 0,
         last_month_refund_value: 0,
         this_month_refund_count: 0,
         this_month_refund_value: 0,
         fee: 0,
         last_month_income: 0,
         this_month_income: 0,
         this_month_estimate_income: 0,
         this_month_estimate_revenue: 0,
         potential_income: 0,
         all_influencers: [],
         portal_influencer: '_',
         n_pending_uncancelled_trials: 0,
         n_pending_cancelled_trials: 0,
         n_pending_cancelled_non_trials: 0,
         n_converted_trials: 0,
         n_cancelled_trials: 0,
         trial_conversion_rate: 0,
         n_converted_trials_time_range: 0,
         n_converted_trials_time_range_change: 0,
         n_cancelled_trials_time_range: 0,
         n_cancelled_trials_time_range_change: 0,
         trial_conversion_rate_time_range: 0,
         trial_conversion_rate_time_range_change: 0,
         //   
         n_total_page_views: 0,
         n_total_content_uploads: 0,
         n_single_content_sales: 0,
         n_collection_sales: 0,
         view_to_trial_rate: 0,
         view_to_free_rate: 0,
         time_range_view_to_trial_rate: 0,
         time_range_view_to_free_rate: 0,
         mainGraphSelected: 'revenue',
         uploadLoading: true,
         graphDataLoading: true,
         overviewData: [],
         overviewPrediction: null,
         currency: '',
         hasViews: true,
         windowWidth: window.innerWidth,
      };
      this.get_and_post_data_skeleton = this.get_and_post_data_skeleton.bind(this);
      this.getGeoInfo = this.getGeoInfo.bind(this);
      this.updateSelected = this.updateSelected.bind(this);
   }


   updateWindowDimensions = () => {
      this.setState({ windowWidth: window.innerWidth });
   };

   componentDidMount() {
      this.updatePredicate();
      window.addEventListener('resize', this.updateWindowDimensions);
      window.addEventListener("resize", this.updatePredicate);
      let currency = this.getGeoInfo(true);
      this.setState({ currency: currency })
      if (!this.props.portal) {
         // Listen for screen size
         this.get_and_post_data_skeleton(
            paths.BACKEND_URL + "api/settings_influencer_analytics_constants/_",
            'get',
            false,
            {},
            null,
            false,
            true,
         )
         this.get_and_post_data_skeleton(
            paths.BACKEND_URL + "api/settings_influencer_analytics_income/_/" + currency,
            'get',
            false,
            {},
            null,
            false,
            true,
         )
         this.get_and_post_data_skeleton(
            paths.BACKEND_URL + "api/settings_influencer_analytics/7/_",
            'get',
            false,
            {},
            null,
            false,
            true,
         )
         axios({
            method: 'get',
            url: paths.BACKEND_URL + "api/settings/insights_revenue_plot/_/" + currency,
            headers: {
               'Content-type': 'application/json',
            },
            withCredentials: true,
         })
            .then((res) => {
               let updatedData = res.data.values;
               if (this.state.mainGraphSelected === 'revenue') {
                  // res.data.values.unshift(['Projected*', res.data.this_month_estimate_value]);
                  res.data.values = res.data.values.map((value, index) => {
                     if (index === 0) {
                        return [value[0], value[1] / 100, res.data.this_month_estimate_value / 100];
                     } else {
                        return [value[0], value[1] / 100, null];
                     }
                     // return [value[0], value[1] / 100];
                  });
                  updatedData = res.data.values;

               } else {
                  // res.data.values.unshift(['Projected*', res.data.this_month_estimate_value]);
                  updatedData = res.data.values;
               }


               this.setState({
                  overviewData: updatedData.reverse(),
                  overviewPrediction: res.data.this_month_estimate_value,
                  uploadLoading: false,
                  graphDataLoading: false,
               })

            })
         const time = performance.now() - this.metricLoadStart;
         logNavigation(time)
      } else {
         // get all influencers
         this.get_and_post_data_skeleton(
            paths.BACKEND_URL + "api/settings_influencer_analytics/get_all_influencers",
            'get',
            false,
            {},
            null,
            false,
            true,
         )

         this.setState({ uploadLoading: false, graphDataLoading: false, })
      }

   }

   componentWillUnmount() {
      window.removeEventListener('resize', this.updateWindowDimensions);
   }


   getInfluencerAnalyticsPortal(portal_influencer) {
      this.setState({ mainGraphSelected: 'revenue' })
      this.get_and_post_data_skeleton(
         paths.BACKEND_URL + "api/settings_influencer_analytics_constants/" + portal_influencer,
         'get',
         false,
         {},
         null,
         false,
         true,
      )
      this.get_and_post_data_skeleton(
         paths.BACKEND_URL + "api/settings_influencer_analytics_income/" + portal_influencer + '/GBP',
         'get',
         false,
         {},
         null,
         false,
         true,
      )
      this.get_and_post_data_skeleton(
         paths.BACKEND_URL + "api/settings_influencer_analytics/7/" + portal_influencer,
         'get',
         false,
         {},
         null,
         false,
         true,
      )
      axios({
         method: 'get',
         url: paths.BACKEND_URL + "api/settings/insights_revenue_plot/" + portal_influencer + '/GBP',
         headers: {
            'Content-type': 'application/json',
         },
         withCredentials: true,
      })
         .then((res) => {

            // if (this.state.mainGraphSelected === 'revenue') {
            //          res.data.values.unshift(['Projected*', res.data.this_month_estimate_value]);
            //          res.data.values = res.data.values.map((value) => {
            //             return [value[0], value[1] / 100];
            //          });
            //          updatedData = res.data.values;

            //       } else {
            //          res.data.values.unshift(['Projected*', res.data.this_month_estimate_value]);
            //          updatedData = res.data.values;
            //       }

            let updatedData = res.data.values;
            if (this.state.mainGraphSelected === 'revenue') {
               // res.data.values.unshift(['Projected*', res.data.this_month_estimate_value]);
               res.data.values = res.data.values.map((value, index) => {
                  if (index === 0) {
                     return [value[0], value[1] / 100, res.data.this_month_estimate_value / 100];
                  } else {
                     return [value[0], value[1] / 100, null];
                  }
                  // return [value[0], value[1] / 100];
               });
               updatedData = res.data.values;

            } else {
               // res.data.values.unshift(['Projected*', res.data.this_month_estimate_value]);
               updatedData = res.data.values;
            }
            // if (this.state.mainGraphSelected === 'revenue') {
            //    res.data.values.unshift(['Projected*', res.data.this_month_estimate_value]);
            //    res.data.values = res.data.values.map((value) => {
            //       return [value[0], value[1] / 100];
            //    });
            //    updatedData = res.data.values;

            // } else {
            //    res.data.values.unshift(['Projected*', res.data.this_month_estimate_value]);
            //    updatedData = res.data.values;
            // }

            this.setState({
               overviewData: updatedData.reverse(),
               overviewPrediction: res.data.this_month_estimate_value,
               uploadLoading: false,
               graphDataLoading: false,
               selected: 'revenue',
            })



            // this.setState({
            //    overviewData: res.data.values.reverse(),
            //    overviewPrediction: res.data.this_month_estimate_value,
            //    uploadLoading: false,
            //    graphDataLoading: false,
            //    selected: 'revenue',
            // })
         })
   }

   updatePredicate = () => {
      this.setState({ windowWidth: window.innerWidth });
      // this.setState({ isDesktop: window.innerWidth > 600 });
      // this.setState({ isExtraSmallDevice: (window.innerWidth < 600) });
      // this.setState({ isSmallDevice: ((window.innerWidth >= 600) && (window.innerWidth < 900)) });
      // this.setState({ isMediumDevice: ((window.innerWidth >= 900) && (window.innerWidth < 1280)) });
      // this.setState({ isLargeDevice: window.innerWidth >= 1280 && (window.innerWidth < 1536) });
      // this.setState({ isXLargeDevice: window.innerWidth >= 1536 })
   }

   get_data_name(data, name_col, value_col) {
      return data.map((entry) => {
         const name = entry[name_col];
         const value = entry[value_col];
         return {
            label: typeof name === 'string' ? name.charAt(0).toUpperCase() + name.slice(1) : name,
            value: value
         }
      })
   }


   updateSelected = (newType) => {
      // console.log('setting loading, true')
      let updatedData = []


      this.setState({
         upload_loading: true,
         graphDataLoading: true,
         mainGraphSelected: newType
      })


      if (newType === 'revenue') {
         axios({
            method: 'get',
            url: paths.BACKEND_URL + "api/settings/insights_revenue_plot/" + this.state.portal_influencer + '/' + this.state.currency,
            headers: {
               'Content-type': 'application/json',
            },
            withCredentials: true,
         })
            .then((res) => {
               // appened res.data.this_month_estimate_value to the end of the array with the earliest month
               res.data.values = res.data.values.map((value, index) => {
                  if (index === 0) {
                     return [value[0], value[1] / 100, res.data.this_month_estimate_value / 100];
                  } else {
                     return [value[0], value[1] / 100, null];
                  }
                  // return [value[0], value[1] / 100];
               });
               let updatedData = res.data.values;


               this.setState({
                  overviewData: updatedData.reverse(),
                  overviewPrediction: res.data.this_month_estimate_value,
                  uploadLoading: false,
                  graphDataLoading: false,
                  mainGraphSelected: newType
               })
            })
      } else if (newType === 'memberships') {
         axios({
            method: 'get',
            url: paths.BACKEND_URL + "api/settings/insights_memberships_plot/" + this.state.portal_influencer,
            headers: {
               'Content-type': 'application/json',
            },
            withCredentials: true,
         })
            .then((res) => {

               res.data.values = res.data.values.map((value, index) => {
                  if (index === 0) {
                     return [value[0], value[1], res.data.this_month_estimate_value];
                  } else {
                     return [value[0], value[1], null];
                  }
                  // return [value[0], value[1] / 100];
               });
               let updatedData = res.data.values;

               this.setState({
                  overviewData: updatedData.reverse(),
                  overviewPrediction: res.data.this_month_estimate_value,
                  uploadLoading: false,
                  graphDataLoading: false,
                  mainGraphSelected: newType
               })
            })
      } else if (newType === 'views') {

         axios({
            method: 'get',
            url: paths.BACKEND_URL + "api/settings/insights_page_view_plot/" + this.state.portal_influencer,
            headers: {
               'Content-type': 'application/json',
            },
            withCredentials: true,
         })
            .then((res) => {

               res.data.values = res.data.values.map((value, index) => {
                  if (index === 0) {
                     return [value[0], value[1], res.data.this_month_estimate_value];
                  } else {
                     return [value[0], value[1], null];
                  }
                  // return [value[0], value[1] / 100];
               });
               let updatedData = res.data.values;

               this.setState({
                  overviewData: updatedData.reverse(),
                  overviewPrediction: res.data.this_month_estimate_value,
                  uploadLoading: false,
                  graphDataLoading: false,
                  mainGraphSelected: newType
               })
            })
      }

   };




   get_and_post_data_skeleton = get_and_post_data_skeleton
   getGeoInfo = getGeoInfo
   render() {

      let currency_symbol = ""
      if (this.state.currency == 'GBP') {
         currency_symbol = '£';
      } else if (this.state.currency == 'EUR') {
         currency_symbol = '€';
      } else if (this.state.currency == 'USD') {
         currency_symbol = '$';
      }


      let page_title = ""
      if (this.props.portal) {
         page_title = (
            <Grid
               xs={6}
               justifyContent="center"
               alignItems="center"
            >
               <Typography
                  style={{
                     color: 'white',
                     fontSize: '18px',
                     fontWeight: '600',
                     textAlign: 'center',
                     paddingTop: '20px',
                  }}
               >Select An Influencer</Typography>
               <FormControl fullWidth hiddenLabel variant="filled"
                  sx={{
                     marginBottom: '20px',
                     backgroundColor: '#444957',
                     border: '0px',
                     borderRadius: '5px',
                     paddingTop: '0px',
                     display: 'block',
                     marginLeft: 'auto',
                     marginRight: 'auto',
                     textAlign: 'left'
                  }}>

                  <Select
                     size="small"
                     displayEmpty
                     disableUnderline
                     fullWidth
                     IconComponent={() => (
                        <FaChevronCircleDown
                           style={{
                              marginRight: '10px',
                              fontSize: '20px',
                              color: 'var(--secondary-icon-color)'
                           }}
                        />
                     )}
                     inputProps={{ 'aria-label': 'Without label' }}
                     // placeholder="Test"
                     labelId="demo-customized-select-label"
                     id="demo-customized-select"
                     value={this.state.portal_influencer}
                     onChange={(event) => {
                        this.setState({
                           portal_influencer: event.target.value,
                        });

                        this.getInfluencerAnalyticsPortal(event.target.value)
                     }
                     }
                     // onFocus={(e) => this.setShowPlaceholder(false)}
                     // onClose={(e) => this.setShowPlaceholder(e.target.value === undefined)}
                     sx={{
                        fontSize: '16px',
                        borderRadius: '5px',
                        color: 'var(--primary-text-color)',
                        // opacity: this.state.show_placeholder ? '0.5' : '1',
                        fontWeight: '800',
                     }}
                  >
                     {/*<MenuItem style={{display: this.state.show_placeholder ? 'flex': 'none'}} disabled value="" >Enquiry Type</MenuItem>*/}
                     {this.state.all_influencers.map(
                        (item) => {
                           return (
                              <MenuItem value={item} sx={{ textAlign: 'left' }}>
                                 {item}
                              </MenuItem>
                           )
                        }
                     )}
                  </Select>
               </FormControl>
            </Grid>
         )
      }
      let week_button = ""
      let month_button = ""
      let year_button = ""
      if (this.state.numDays === 7) {

         week_button = <Button
            disableRipple size="small" key="7" sx={{
               padding: '5px 10px',
               backgroundColor: this.state.numDays === 7 ? 'var(--brand-color)' : '#fff',
               color: this.state.numDays === 7 ? '#fff' : '#222222',
               fontSize: 'var(--small-text)', fontWeight: '500',
               '&:hover': {
                  color: {xs: '#fff', md: 'var(--brand-color)'},
                  backgroundColor: {xs: 'var(--brand-color)', md: '#fff'}
               }
            }}
            onClick={() => this.setState({ numDays: 7 })}
         >
            7 days
         </Button>
      } else {
         week_button = <Button
            disableRipple size="small" key="7" sx={{
               padding: '5px 10px',
               backgroundColor: this.state.numDays === 7 ? 'var(--brand-color)' : '#fff',
               color: this.state.numDays === 7 ? '#fff' : '#222222',
               fontSize: 'var(--small-text)', fontWeight: '500',
               '&:hover': {
                  color: {xs: '#fff', md: 'var(--brand-color)'},
                  backgroundColor: {xs: 'var(--brand-color)', md: '#fff'}
               }
            }}
            onClick={() => {
               this.setState({ numDays: 7 })
               this.get_and_post_data_skeleton(
                  paths.BACKEND_URL + "api/settings_influencer_analytics/7/" + this.state.portal_influencer,
                  'get',
                  false,
                  {},
                  null,
                  false,
                  true,
               )
            }}
         >
            7 days
         </Button>
      }
      if (this.state.numDays === 30) {

         month_button = <Button
            disableRipple size="small" key="30" sx={{
               padding: '5px 10px',
               backgroundColor: this.state.numDays === 30 ? 'var(--brand-color)' : '#fff',
               color: this.state.numDays === 30 ? '#fff' : '#222222',
               fontSize: 'var(--small-text)', fontWeight: '500',
               '&:hover': {
                  color: {xs: '#fff', md: 'var(--brand-color)'},
                  backgroundColor: {xs: 'var(--brand-color)', md: '#fff'}
               }
            }}
         >
            30 days
         </Button>
      } else {
         month_button = <Button
            disableRipple size="small" key="30" sx={{
               padding: '5px 10px',
               backgroundColor: this.state.numDays === 30 ? 'var(--brand-color)' : '#fff',
               color: this.state.numDays === 30 ? '#fff' : '#222222',
               fontSize: 'var(--small-text)', fontWeight: '500',
               '&:hover': {
                  color: {xs: '#fff', md: 'var(--brand-color)'},
                  backgroundColor: {xs: 'var(--brand-color)', md: '#fff'}
               }
            }}
            onClick={() => {
               this.setState({ numDays: 30 })
               this.get_and_post_data_skeleton(
                  paths.BACKEND_URL + "api/settings_influencer_analytics/30/" + this.state.portal_influencer,
                  'get',
                  false,
                  {},
                  null,
                  false,
                  true,
               )
            }}
         >
            30 days
         </Button>
      }
      if (this.state.numDays === 365) {

         year_button = <Button
            disableRipple size="small" key="365" sx={{
               padding: '5px 10px',
               backgroundColor: this.state.numDays === 365 ? 'var(--brand-color)' : '#fff',
               color: this.state.numDays === 365 ? '#fff' : '#222222',
               fontSize: 'var(--small-text)', fontWeight: '500',
               '&:hover': {
                  color: {xs: '#fff', md: 'var(--brand-color)'},
                  backgroundColor: {xs: 'var(--brand-color)', md: '#fff'}
               }
            }}
         >
            365 days
         </Button>
      } else {
         year_button = <Button
            disableRipple size="small" key="365" sx={{
               padding: '5px 10px',
               backgroundColor: this.state.numDays === 365 ? 'var(--brand-color)' : '#fff',
               color: this.state.numDays === 365 ? '#fff' : '#222222',
               fontSize: 'var(--small-text)', fontWeight: '500',
               '&:hover': {
                  color: {xs: '#fff', md: 'var(--brand-color)'},
                  backgroundColor: {xs: 'var(--brand-color)', md: '#fff'}
               }
            }}
            onClick={() => {
               this.setState({ numDays: 365 })
               this.get_and_post_data_skeleton(
                  paths.BACKEND_URL + "api/settings_influencer_analytics/365/" + this.state.portal_influencer,
                  'get',
                  false,
                  {},
                  null,
                  false,
                  true,
               )
            }}
         >
            365 days
         </Button>
      }
      let n_sub_new_class = ''
      let n_sub_upgrade_class = ''
      let n_sub_free_upgrade_class = ''
      let n_sub_downgrade_class = ''
      let n_sub_cancel_class = ''
      let n_page_view_class = ''
      let n_content_upload_class = ''
      let n_converted_trials_class = ''
      let n_cancelled_trials_class = ''
      let n_trial_conversion_rate_class = ''
      if (String(this.state.n_sub_new_change) === '0') {
         n_sub_new_class = 'percentage_text_neutral'
      } else if (String(this.state.n_sub_new_change)[0] === '-') {
         n_sub_new_class = 'percentage_text_negative'
      } else {
         n_sub_new_class = 'percentage_text_positive'
      }
      if (String(this.state.n_sub_upgrades_change) === '0') {
         n_sub_upgrade_class = 'percentage_text_neutral'
      } else if (String(this.state.n_sub_upgrades_change)[0] === '-') {
         n_sub_upgrade_class = 'percentage_text_negative'
      } else {
         n_sub_upgrade_class = 'percentage_text_positive'
      }
      if (String(this.state.n_sub_free_upgrades_change) === '0') {
         n_sub_free_upgrade_class = 'percentage_text_neutral'
      } else if (String(this.state.n_sub_free_upgrades_change)[0] === '-') {
         n_sub_free_upgrade_class = 'percentage_text_negative'
      } else {
         n_sub_free_upgrade_class = 'percentage_text_positive'
      }
      if (String(this.state.n_sub_downgrades_change) === '0') {
         n_sub_downgrade_class = 'percentage_text_neutral'
      } else if (String(this.state.n_sub_downgrades_change)[0] === '-') {
         n_sub_downgrade_class = 'percentage_text_positive'
      } else {
         n_sub_downgrade_class = 'percentage_text_negative'
      }
      if (String(this.state.n_sub_cancel_change) === '0') {
         n_sub_cancel_class = 'percentage_text_neutral'
      } else if (String(this.state.n_sub_cancel_change)[0] === '-') {
         n_sub_cancel_class = 'percentage_text_positive'
      } else {
         n_sub_cancel_class = 'percentage_text_negative'
      }
      if (String(this.state.n_page_views_change) === '0') {
         n_page_view_class = 'percentage_text_neutral'
      } else if (String(this.state.n_page_views_change)[0] === '-') {
         n_page_view_class = 'percentage_text_negative'
      } else {
         n_page_view_class = 'percentage_text_positive'
      }
      if (String(this.state.n_uploaded_content_change) === '0') {
         n_content_upload_class = 'percentage_text_neutral'
      } else if (String(this.state.n_uploaded_content_change)[0] === '-') {
         n_content_upload_class = 'percentage_text_negative'
      } else {
         n_content_upload_class = 'percentage_text_positive'
      }
      if (String(this.state.n_converted_trials_time_range_change) === '0') {
         n_converted_trials_class = 'percentage_text_neutral'
      } else if (String(this.state.n_converted_trials_time_range_change)[0] === '-') {
         n_converted_trials_class = 'percentage_text_negative'
      } else {
         n_converted_trials_class = 'percentage_text_positive'
      }
      if (String(this.state.n_cancelled_trials_time_range_change) === '0') {
         n_cancelled_trials_class = 'percentage_text_neutral'
      } else if (String(this.state.n_cancelled_trials_time_range_change)[0] === '-') {
         n_cancelled_trials_class = 'percentage_text_positive'
      } else {
         n_cancelled_trials_class = 'percentage_text_negative'
      }
      if (String(this.state.trial_conversion_rate_time_range_change) === '0') {
         n_trial_conversion_rate_class = 'percentage_text_neutral'
      } else if (String(this.state.trial_conversion_rate_time_range_change)[0] === '-') {
         n_trial_conversion_rate_class = 'percentage_text_negative'
      } else {
         n_trial_conversion_rate_class = 'percentage_text_positive'
      }
      // console.log('test111')
      // console.log(this.state.overviewData)
      // console.log(this.state.overviewPrediction)



      const cardStyle = {
         border: '1px solid #E4EBF6',
         borderRadius: '8px',
         padding: '25px 20px 30px 20px',
         backgroundColor: '#fff',
         marginTop: '20px',
         height: 'auto',
         width: 'auto'
      };

      const headingStyle = {
         ...smallHeading,
         textAlign: 'center',
         margin: '0px 0px 15px 0px'
      };

      const report1 = [
         {
            title: 'Views and Uploads',
            data: [
               { label: 'Platform Views', value: this.state.n_total_page_views },
               { label: 'Content Uploads', value: this.state.n_total_content_uploads },
               { label: 'View to Free Sub Rate', value: `${this.state.view_to_free_rate}%` },
               { label: 'View to Paid Trial Rate', value: `${this.state.view_to_trial_rate}%` }
            ]
         },
         {
            title: 'Pending Actions',
            data: [
               { label: 'Cancelled - Paid Sub', value: this.state.n_pending_cancelled_non_trials },
               { label: 'Cancelled - Free Trial', value: this.state.n_pending_cancelled_trials },
               { label: 'Uncancelled - Free Trial', value: this.state.n_pending_uncancelled_trials },
            ]
         },
         {
            title: 'Income',
            data: [
               { label: 'Last Month', value: CreatePriceStr(this.state.last_month_income, this.state.currency) },
               { label: 'So Far This Month', value: CreatePriceStr(this.state.this_month_income, this.state.currency) },
               { label: 'This Month Estimate', value: CreatePriceStr(this.state.this_month_estimate_income, this.state.currency) },
               { label: 'Potential In a Year', value: CreatePriceStr(this.state.potential_income, this.state.currency) },
            ]
         },
         {
            title: 'Revenue and Fees',
            data: [
               { label: 'Last Month', value: CreatePriceStr(this.state.prev_month_revenue, this.state.currency) },
               { label: 'So Far This Month', value: CreatePriceStr(this.state.this_month_revenue, this.state.currency) },
               { label: 'This Month Estimate', value: CreatePriceStr(this.state.this_month_estimate_revenue, this.state.currency) },
               { label: 'WithMe Fee', value: this.state.fee + '%' },
            ]
         },
         {
            title: 'Refunds',
            data: [
               { label: 'Count - Last Month', value: CreatePriceStr(this.state.last_month_refund_count, this.state.currency) },
               { label: 'Value - Last Month', value: CreatePriceStr(this.state.last_month_refund_value, this.state.currency) },
               { label: 'Count - This Month', value: CreatePriceStr(this.state.this_month_refund_count, this.state.currency) },
               { label: 'Value - This Month', value: CreatePriceStr(this.state.this_month_refund_value, this.state.currency) },
            ]
         },
      ]

      const report2 = [
         {
            title: 'Membership Changes',
            data: [
               { label: 'New', value: this.state.n_sub_new, subValue: `${this.state.n_sub_new_change}%` },
               { label: 'Free Upgraded', value: this.state.n_sub_free_upgrades, subValue: `${this.state.n_sub_free_upgrades_change}%` },
               { label: 'Paid Upgraded', value: this.state.n_sub_upgrades, subValue: `${this.state.n_sub_upgrades_change}%` },
               { label: 'Downgraded', value: this.state.n_sub_downgrades, subValue: `${this.state.n_sub_downgrades_change}%` },
               { label: 'Cancelled', value: this.state.n_sub_cancellations, subValue: `${this.state.n_sub_cancel_change}%` },
            ]
         },
         {
            title: 'Trials',
            data: [
               { label: 'Converted Trials', value: this.state.n_converted_trials_time_range, subValue: `${this.state.n_converted_trials_time_range_change}%` },
               { label: 'Cancelled Trials', value: this.state.n_cancelled_trials_time_range, subValue: `${this.state.n_cancelled_trials_time_range_change}%` },
               { label: 'Trial Conversion Rate', value: this.state.trial_conversion_rate_time_range, subValue: `${this.state.trial_conversion_rate_time_range_change}%` },
            ]
         },
         {
            title: 'Views and Uploads',
            data: [
               { label: 'Platform Views', value: this.state.n_page_views, subValue: `${this.state.n_page_views_change}%` },
               { label: 'New Content', value: this.state.n_uploaded_content, subValue: `${this.state.n_uploaded_content_change}%` },
               { label: 'View to Free Sub Rate', value: `${this.state.time_range_view_to_free_rate}%`, subValue: `` },
               { label: 'View to Paid Trial (or direct sub) Rate', value: `${this.state.time_range_view_to_trial_rate}%`, subValue: `` },
            ]
         },
      ]      


      return (
         <>
            {page_title}
            
            {this.state.uploadLoading ?
               <>

                  <PageSkeletonAnalytics />
               </>
               : (
                  <div className='container'>



                     <Grid
                        container
                        spacing={0}
                        alignItems="center"
                        justifyContent="center"
                        sx={{ marginBottom: '20px', }}
                     >

                        {/* Personal Stats Number Based */}


                        {/* New Analytics */}
                        {/* <Loader 
                  loading={this.state.uploadLoading} 
                  label={"Getting Data..."} 
               /> */}



                        <Box sx={{ width: '100%' }}>
                           <Grid container justifyContent={'space-between'}>
                              <Grid item xs={12} md={5.9} lg={2.9} sx={{ height: 'auto', width: '100%', marginTop: {xs: '0px', lg: '0px'} }}>
                                 <TopBox title="Monthly Income" value={CreatePriceStr(this.state.this_month_income, this.state.currency)} change="20%" icon={<FiDollarSign style={{ color: '#6E89AF' }} />} />
                              </Grid>
                              <Grid item xs={12} md={5.9} lg={2.9} sx={{ height: 'auto', width: '100%', marginTop: {xs: '20px', lg: '0px'} }}>
                                 <TopBox title={"Paid Memberships"} value={this.state.n_bronze_subs + this.state.n_silver_subs + this.state.n_gold_subs} change="10%" icon={<FiUsers style={{ color: '#6E89AF' }} />} />
                              </Grid>
                              <Grid item xs={12} md={5.9} lg={2.9} sx={{ height: 'auto', width: '100%', marginTop: {xs: '20px', lg: '0px'} }}>
                                 <TopBox title="Free Trials" value={this.state.n_free_subs} change="30%" icon={<FiAward style={{ color: '#6E89AF' }} />} />
                              </Grid>
                              <Grid item xs={12} md={5.9} lg={2.9} sx={{ height: 'auto', width: '100%', marginTop: {xs: '20px', lg: '0px'} }}>
                                 <TopBox title="Page Views" value={this.state.n_total_page_views} change="10%" icon={<FiEye style={{ color: '#6E89AF' }} />} />
                              </Grid>
                              <Grid item xs={12} md={12} lg={12} sx={{ height: 'auto', width: '100%', marginTop: '20px' }}>
                                 <MonthlyOverview selected={this.state.mainGraphSelected} currency={this.state.currency} windowWidth={this.state.windowWidth} updateSelected={this.updateSelected}
                                    overviewData={this.state.overviewData}
                                    // overviewData={this.state.mainGraphSelected === 'revenue' ? dataTest1 : (this.state.mainGraphSelected === 'memberships' ? dataTest2 : dataTest3)}
                                    graphDataLoading={this.state.graphDataLoading} />

                              </Grid>
                              {/* <Grid item xs={12} md={5.9} lg={3.9} sx={{ height: 'auto', width: '100%', marginTop: '20px' }}>
                        <LatestMembers currency_symbol={currency_symbol}/>
                     </Grid> */}
                              {/* <Grid item xs={12} md={5.9} lg={4.9} sx={{ height: 'auto', width: '100%', marginTop: '20px' }}>
                        <MembershipBreakdown />
                     </Grid> */}

                              {/* <Grid item xs={12} md={5.9} lg={4.9} sx={{ height: 'auto', width: '100%', marginTop: '20px' }}>
                        <MembershipRadarChart />
                     </Grid>

                     <Grid item xs={12} md={5.9} lg={6.9} sx={{ height: 'auto', width: '100%', marginTop: '20px' }}>
                        <MonthlyComposedChart />
                     </Grid> */}


                           </Grid>
                        </Box>








                        <Grid
                           container
                           spacing={0}
                           alignItems="center"
                           justifyContent={'space-between'}
                        >
                           {
                              report1.map((item, index) => {
                                 return (
                                    <Grid
                                       key={index}
                                       container
                                       spacing={2}
                                       sx={{
                                          flexDirection: { xs: 'column', md: 'row' },
                                          textAlign: { xs: 'center', md: 'left' }
                                       }}
                                    >
                                       <Grid item xs={12}>
                                          <div style={cardStyle}>
                                             <p style={headingStyle}>{item.title}</p>
                                             <Grid
                                                container
                                                spacing={2}
                                                sx={{
                                                   flexDirection: { xs: 'column', md: 'row' },
                                                   textAlign: { xs: 'center', md: 'left' }
                                                }}
                                             >
                                                {item.data.map((item, index) => (
                                                   <Grid item xs={12} sm={6} md={3} key={index}>
                                                      <Box sx={{
                                                         display: 'flex',
                                                         flexDirection: { xs: 'column', md: 'column' },
                                                         alignItems: 'center'
                                                      }}>
                                                         <p className='small_info_text'>{item.value}</p>
                                                         <p className='analytics_item_description'>{item.label}</p>
                                                      </Box>
                                                   </Grid>
                                                ))}
                                             </Grid>
                                          </div>
                                       </Grid>
                                    </Grid>
                                 )
                              })
                           }

                        </Grid>


                        <Grid xs={12}>
                           <div
                              sx={{
                                 color: 'black',
                                 display: 'flex',
                                 flexDirection: 'column',
                                 alignItems: 'center',
                                 '& > *': {
                                    xs: 1,
                                 },
                              }}
                           >
                              <div style={{ textAlign: 'center', float: 'center', margin: '40px 0px 0px 0px' }}>
                                 <Typography
                                    style={{ ...smallHeading, margin: '0px 0px 10px' }}

                                 >
                                    Trends In The last ...
                                 </Typography>
                                 {/*<ButtonGroup disableTypography variant="text" size="small" aria-label="small button group"*/}
                                 {/*             sx={{*/}
                                 {/*                 textAlign: 'right',*/}
                                 {/*                 float: 'right',*/}
                                 {/*                 color: 'black'*/}
                                 {/*             }}>*/}

                                 {week_button}
                                 {month_button}
                                 {year_button}
                                 {/*</ButtonGroup>*/}</div>
                           </div>
                        </Grid>

                        <Grid
                           container
                           spacing={0}
                           alignItems="center"
                           justifyContent={'space-between'}
                        >
                           {
                              report2.map((item, index) => {
                                 return (
                                    <Grid
                                       key={index}
                                       container
                                       spacing={2}
                                       sx={{
                                          flexDirection: { xs: 'column', md: 'row' },
                                          textAlign: { xs: 'center', md: 'left' }
                                       }}
                                    >
                                       <Grid item xs={12}>
                                          <div style={cardStyle}>
                                             <p style={headingStyle}>{item.title}</p>
                                             <Grid
                                                container
                                                spacing={2}
                                                sx={{
                                                   flexDirection: { xs: 'column', md: 'row' },
                                                   textAlign: { xs: 'center', md: 'left' }
                                                }}
                                             >
                                                {item.data.map((item, index) => (
                                                   <Grid item xs={12} sm={6} md={3} key={index}>
                                                      <Box sx={{
                                                         display: 'flex',
                                                         flexDirection: { xs: 'column', md: 'column' },
                                                         alignItems: 'center'
                                                      }}>
                                                         <div style={{
                                                            display: 'flex',
                                                            width: '100%',
                                                            textAlign: 'center',
                                                            marginLeft: 'auto',
                                                            marginRight: 'auto'
                                                         }}>
                                                            <p style={{ display: 'inline-block', textAlign: 'right', paddingLeft: '10px' }}
                                                               className='small_info_text'>{item.value}</p>
                                                            <p className={n_converted_trials_class}>{item.subValue}</p></div>
                                                         <p className='analytics_item_description'>{item.label}</p>
                                                      </Box>
                                                   </Grid>
                                                ))}
                                             </Grid>
                                          </div>
                                       </Grid>
                                    </Grid>
                                 )
                              })
                           }
                        </Grid>

                        <Grid
                           container
                           spacing={0}
                           alignItems="center"
                           justifyContent="space-between">
                           <Grid
                              container
                              spacing={0}
                              alignItems="stretch"
                              sx={{ margin: '0px 0px 0px 0px', height: '100%' }}
                              justifyContent="space-between">
                              {/* Pies */}
                              <Grid xs={12} sm={5.9} md={3.9} lg={3.9} >
                                 <TopFive top_five_data={this.state.top_5_content_views} title={'Top 5 Most Viewed Content'} />
                              </Grid>
                              <Grid xs={12} sm={5.9} md={3.9} lg={3.9} sx={{ minHeight: '300px' }}>
                                 <TopFive top_five_data={this.state.top_5_content_likes} title={'Top 5 Most Liked Content'} />
                              </Grid>
                              <Grid xs={12} sm={5.9} md={3.9} lg={3.9} sx={{ minHeight: '300px' }}>
                                 <TopFive top_five_data={this.state.top_5_content_save} title={'Top 5 Most Saved Content'} />
                              </Grid>
                           </Grid>
                           <Grid
                              container
                              spacing={0}
                              alignItems="stretch"
                              justifyContent="space-between">
                              {/* Pies */}
                              <Grid xs={12} sm={5.9} md={3.9} lg={3.9}>
                                 <PieCard data={this.get_data_name(this.state.uploaded_content_categories, 'category__category', 'num_uploads')} title={'Upload Categories'} />
                              </Grid>
                              <Grid xs={12} sm={5.9} md={3.9} lg={3.9} sx={{ minHeight: '300px' }}>
                                 <PieCard data={this.get_data_name(this.state.uploaded_content_content_type, 'content_type', 'num_uploads')} title={'Upload Content Types'} />
                              </Grid>
                              <Grid xs={12} sm={5.9} md={3.9} lg={3.9} sx={{ minHeight: '300px' }}>
                                 <PieCard data={this.get_data_name(this.state.uploaded_content_content_tier, 'tier', 'num_uploads')} title={'Upload Content Tiers'} colors={TIER_COLORS} />
                              </Grid>
                           </Grid>
                           <Grid
                              container
                              spacing={0}
                              alignItems="stretch"
                              justifyContent="space-between">
                              {/* Pies */}
                              <Grid xs={12} sm={5.9} md={3.9} lg={3.9} sx={{ minHeight: '300px' }}>
                                 <PieCard data={this.get_data_name(this.state.content_category_views, 'content__category__category', 'num_views')} title={'Viewed Categories'} />
                              </Grid>
                              <Grid xs={12} sm={5.9} md={3.9} lg={3.9} sx={{ minHeight: '300px' }}>
                                 <PieCard data={this.get_data_name(this.state.content_content_type_views, 'content__content_type', 'num_views')} title={'Viewed Content Types'} />
                              </Grid>
                              <Grid xs={12} sm={5.9} md={3.9} lg={3.9} sx={{ minHeight: '300px' }}>
                                 <PieCard data={this.get_data_name(this.state.content_tier_views, 'content__tier', 'num_views')} title={'Viewed Tiers'} colors={TIER_COLORS} />
                              </Grid>
                           </Grid>
                           <Grid
                              container
                              spacing={0}
                              alignItems="stretch"
                              justifyContent="space-between">
                              {/* Pies */}
                              <Grid xs={12} sm={5.9} md={3.9} lg={3.9} sx={{ minHeight: '300px' }}>
                                 <PieCard data={this.get_data_name(this.state.content_category_likes, 'content__category__category', 'num_likes')} title={'Liked Categories'} />
                              </Grid>
                              <Grid xs={12} sm={5.9} md={3.9} lg={3.9} sx={{ minHeight: '300px' }}>
                                 <PieCard data={this.get_data_name(this.state.content_content_type_likes, 'content__content_type', 'num_likes')} title={'Liked Content Types'} />
                              </Grid>
                              <Grid xs={12} sm={5.9} md={3.9} lg={3.9} sx={{ minHeight: '300px' }}>
                                 <PieCard data={this.get_data_name(this.state.content_tier_likes, 'content__tier', 'num_likes')} title={'Liked Tiers'} colors={TIER_COLORS} />
                              </Grid>
                           </Grid>
                           <Grid
                              container
                              spacing={0}
                              alignItems="stretch"
                              justifyContent="space-between">
                              {/* Pies */}
                              <Grid xs={12} sm={5.9} md={3.9} lg={3.9} sx={{ minHeight: '300px' }}>
                                 <PieCard data={this.get_data_name(this.state.content_category_save, 'content__category__category', 'num_saves')} title={'Saved Categories'} />
                              </Grid>
                              <Grid xs={12} sm={5.9} md={3.9} lg={3.9} sx={{ minHeight: '300px' }}>
                                 <PieCard data={this.get_data_name(this.state.content_content_type_save, 'content__content_type', 'num_saves')} title={'Saved Content Types'} />
                              </Grid>
                              <Grid xs={12} sm={5.9} md={3.9} lg={3.9} sx={{ minHeight: '300px' }}>
                                 <PieCard data={this.get_data_name(this.state.content_tier_save, 'content__tier', 'num_saves')} title={'Saved Tiers'} colors={TIER_COLORS} />
                              </Grid>

                           </Grid>
                        </Grid>
                     </Grid>

                  </div>
               )}
         </>
      )
   }
}

export default InfluencerAnalytics;